export default __webpack_public_path__ + "static/media/star_empty.a00cdb9d.svg";